<template>
    <div>
        <div
            id="content"
            class="content animated slideInRight delay-1s"
        >
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">
                            <div class="card-title">
                                Exportar Usuários
                                <span
                                    class="required_fields"
                                >
                                    <span class="required">*</span>
                                    Campos obrigatórios
                                </span
                                >
                            </div>
                        </div>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <form
                                        :action="$store.state.url + 'export/users'"
                                        id="export"
                                    >
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <label
                                                        for="carDateEnd"
                                                    >
                                                        <span class="required">*</span>
                                                        Filtrar por
                                                        Centro de Custo
                                                    </label
                                                    >
                                                    <v-select
                                                        id="costCenter"
                                                        :options="costCenters"
                                                        label="erp_code"
                                                        :reduce="(costCenter) => costCenter.id"
                                                        v-model="cost_center_id"
                                                        placeholder="Todos os Centros de Custo"
                                                        :clearable="true"
                                                        class="style-chooser"
                                                    >
                                                        <div slot="no-options">Nenhum centro de custo encontrado</div>
                                                    </v-select>
                                                    <input
                                                        type="hidden"
                                                        v-model="this.$store.state.user.id"
                                                        class="form-control"
                                                        name="uid"
                                                        id="uid"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <hr/>
                                        <div class="block text-right">
                                            <a
                                                @click="checkForm"
                                                class="btn btn-add"
                                            >
                                                Exportar em Excel
                                                <i class="fas fa-file-export ml-2"></i>
                                            </a>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CtkDateTimePicker from "vue-ctk-date-time-picker";
import {getMessage} from "../../composables/message";

export default {
    data() {
        return {
            costCenters: [
                {
                    id: '0',
                    erp_code: "Todos os Centros de Custo",
                }
            ],
            cost_center_id: '0',
        };
    },
    methods: {
        checkForm: function () {
            if (this.cost_center_id == "") {
                swal("Erro", "Os dados do formulário não podem ser vazios", "error");
            } else {
                document.getElementById("export").submit();
            }
        },
        getCostCenters: function () {
            const self = this;
            const api = self.$store.state.api + "cost-centers/?paginated=false";

            self.$http
                .get(api)
                .then((response) => {
                    self.costCenters = [
                        {
                            id: '0',
                            erp_code: "Todos os Centros de Custo",
                        },
                        ...response.data.data
                    ];
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
    },
    mounted: function () {
        const self = this;
        self.getCostCenters();
    },
    components: {
        CtkDateTimePicker,
    },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Exportation/Users.vue